
import GLightbox from 'glightbox';
import { getElement, getElements, ifSelectorExist } from './utils';

export const masonryGallery = () => {
  const galleryItem = getElements('.gallery-item a');
  if (ifSelectorExist(galleryItem)) {
    let galleryData = [];
    Array.from(galleryItem).forEach((innerElem, index) => {
      galleryData.push({
        href: innerElem.getAttribute('href'),
        type: 'image',
      });

      innerElem.setAttribute('data-slide', index)
    });

    Array.from(galleryItem).forEach(item => {

      item.addEventListener('click', (e) => {
        e.preventDefault();
        gallerySection.openAt(item.getAttribute('data-slide'));
      })
    })

    const customLightboxHTML = `<div id="glightbox-body" class="glightbox-container">
    <div class="gloader visible"></div>
    <div class="goverlay"></div>
    <div class="gcontainer">
    <div id="glightbox-slider" class="gslider"></div>
    <button class="gnext gbtn" tabindex="0" aria-label="Next" data-customattribute="example">{nextSVG}</button>
    <button class="gprev gbtn" tabindex="1" aria-label="Previous">{prevSVG}</button>
    <button class="gclose gbtn" tabindex="2" aria-label="Close">{closeSVG}</button>
</div>
</div>`;

    let customSlideHTML = `<div class="gslide">
    <div class="gslide-inner-content">
        <div class="ginner-container">
            <div class="gslide-media">
            </div>
            <div class="gslide-description">
                <div class="gdesc-inner">
                    <h4 class="gslide-title"></h4>
                    <div class="gslide-desc"></div>
                </div>
            </div>
        </div>
    </div>
</div>`;


    let gallerySection = GLightbox({
      elements: galleryData,
      autoplayVideos: true,
      zoomable: true,
      lightboxHTML: customLightboxHTML,
      slideHTML: customSlideHTML,
    });

  }
}